import Base from './base';

export default {
  getList: async (): Promise<any> => (await Base()).get('users/my-points'),
};
